import axios from 'axios'

import msg from './msg'



axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
const service = axios.create({
    // baseURL: process.env.VUE_APP_URL,
    baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_URL : "/api",
    timeout: 10000
})
// request拦截器
service.interceptors.request.use(config => {
    // 是否需要设置 token
    // const isToken = (config.headers || {}).isToken === false
    config.headers['x-auth-token'] = localStorage.getItem('token') || ''
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
        let url = config.url + '?';
        for (const propName of Object.keys(config.params)) {
            const value = config.params[propName];
            var part = encodeURIComponent(propName) + "=";
            if (value !== null && typeof (value) !== "undefined") {
                if (typeof value === 'object') {
                    for (const key of Object.keys(value)) {
                        if (value[key] !== null && typeof (value[key]) !== 'undefined') {
                            let params = propName + '[' + key + ']';
                            let subPart = encodeURIComponent(params) + '=';
                            url += subPart + encodeURIComponent(value[key]) + '&';
                        }
                    }
                } else {
                    url += part + encodeURIComponent(value) + "&";
                }
            }
        }
        url = url.slice(0, -1);
        config.params = {};
        config.url = url;
    }
    return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    let code = res.data.code || 1
    if (code == 500) {
        return msg.error(res.data.msg)
    }
    return res  // 返回完整响应对象，包含headers
},
    error => {
        return Promise.reject(error)
    }
)

export default service
